/* ==========================================================================
   Naudet (ClaudIA) — Page d'accueil : repli de la sortie vidéo
   2026-08-04.

   `assets/naudet-accueil.css` fait tout le travail avec une animation liée au
   défilement (`animation-timeline: view()`). Elle tourne hors du fil principal
   et c'est de loin la meilleure façon de faire… là où elle existe.

   ⚠ Firefox ne la gère pas (vérifié par Denis le 04/08 : aucun effet visible).
     Ce fichier reprend donc le même mouvement en JavaScript — MAIS UNIQUEMENT
     si le navigateur ne sait pas le faire tout seul. Sur Chromium et Safari,
     ce script se retire immédiatement et laisse le CSS opérer : pas question
     de remplacer une animation hors fil principal par un écouteur de
     défilement là où ce n'est pas nécessaire.

   Les valeurs sont volontairement IDENTIQUES à celles du CSS. Si l'une bouge,
   l'autre doit suivre — sinon l'effet diffère selon le navigateur.
   ========================================================================== */

(() => {
  'use strict';

  // 1. Le navigateur sait faire ? On ne fait rien.
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) return;

  // 2. Le visiteur a demandé moins d'animation ? On ne fait rien.
  //    Même garde que le CSS : une mise au point qui se perd est exactement le
  //    genre de mouvement qui gêne les personnes sujettes au mal des transports.
  const calme = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (calme.matches) return;

  const demarrer = () => {
    const grille = document.querySelector(
      '[data-template="index"] .hero__media-grid'
    );
    if (!grille) return;

    // Même cible que le CSS : la SECTION, pas le calque média. Le parent
    // immédiat du calque est en `overflow: hidden` ; c'est sans effet ici
    // (on calcule nous-mêmes), mais garder la même cible garantit un rendu
    // identique dans les deux chemins.
    const sujet = grille.closest('.shopify-section') || grille;

    // Valeurs miroir du CSS — cf. naudet-accueil.css. Si l'une bouge ici,
    // elle doit bouger là-bas, sinon l'effet diffère selon le navigateur.
    const COURSE = 360;   // px de défilement sur lesquels l'effet se joue
    const DERIVE = 6;    // % de translateY
    const ECHELLE = 0.14; // agrandissement final
    const FLOU = 18;      // px

    let enAttente = false;
    let dernier = -1;

    const peindre = () => {
      enAttente = false;

      // Miroir du CSS : `scroll(root)` sur une course de COURSE pixels, comptés
      // depuis le PREMIER pixel de défilement.
      // ⚠ La version d'origine partait du rectangle de la section (`-r.top /
      //   r.height`), ce qui reproduisait la plage `exit` — donc un démarrage
      //   seulement après 154 px, quand la vidéo passe déjà sous l'en-tête
      //   fixe. Effet invisible en pratique (retour Denis du 04/08).
      let p = (window.scrollY || window.pageYOffset || 0) / COURSE;
      p = p < 0 ? 0 : p > 1 ? 1 : p;

      // Rien de neuf à peindre : on épargne un repaint.
      if (Math.abs(p - dernier) < 0.005 && p !== 0 && p !== 1) return;
      dernier = p;

      if (p === 0) {
        sujet.style.opacity = '';
        sujet.style.transform = '';
        sujet.style.filter = '';
        sujet.style.willChange = '';
        return;
      }

      sujet.style.willChange = 'opacity, transform, filter';
      sujet.style.opacity = String(1 - p);
      sujet.style.transform =
        'translateY(' + (DERIVE * p).toFixed(2) + '%) scale(' +
        (1 + ECHELLE * p).toFixed(4) + ')';
      sujet.style.filter = 'blur(' + (FLOU * p).toFixed(2) + 'px)';
    };

    const auDefilement = () => {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(peindre);
    };

    // `passive` : on ne bloque jamais le défilement.
    window.addEventListener('scroll', auDefilement, { passive: true });
    window.addEventListener('resize', auDefilement, { passive: true });
    peindre();

    // Si le visiteur active la réduction d'animation en cours de route, on
    // rend la section à son état d'origine.
    calme.addEventListener('change', (e) => {
      if (!e.matches) return;
      window.removeEventListener('scroll', auDefilement);
      window.removeEventListener('resize', auDefilement);
      sujet.style.opacity = '';
      sujet.style.transform = '';
      sujet.style.filter = '';
      sujet.style.willChange = '';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }
})();
